import { type AnchorHTMLAttributes, forwardRef } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

/**
 * An A component.
 */
const A = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>(({ children, className, ...props }, ref) => (
	<a ref={ref} className={cn('a', className)} {...props}>
		{children}
	</a>
))
A.displayName = 'A'

export { A }
